import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      {/* HERO */}
      <section className="policy-hero">
        <div className="policy-hero-content">
          <h1>Privacy Policy</h1>
        </div>
      </section>

      {/* CONTENT */}
      <section className="policy-section">
        <div className="policy-container">
          <div className="policy-wrapper">

            <h2>WHAT TYPES OF PERSONAL INFORMATION DO WE COLLECT?</h2>
            <p>
              We collect and generate different types of Personal Information depending on how you use or interact with our Services.
              “Personal Information” means information that identifies, describes, or is reasonably capable of being associated with you.
            </p>

            <h3>Demographic and Contact Information</h3>
            <p>Name, mailing address, email address, and telephone number.</p>

            <h3>Online or Other Account Information</h3>
            <p>Username, email address, passwords, and security information.</p>

            <h3>Webforms and Requests</h3>
            <p>Information submitted through contact forms, newsletters, or inquiries.</p>

            <h3>Websites</h3>
            <p>Browser type, IP address, pages visited, and clickstream data.</p>

            <h3>Mobile Apps</h3>
            <p>Device type, OS version, platform, and usage analytics.</p>

            <h3>Device Information</h3>
            <p>Hardware model, operating system, unique identifiers.</p>

            <h3>Log Information</h3>
            <p>Search queries, visited pages, and interaction behavior.</p>

            <h3>Location Information</h3>
            <p>General location derived from IP or region selection.</p>

            <h3>Business Interactions</h3>
            <p>Business contact details, product interests, and communications.</p>

            <h3>Financial Information</h3>
            <p>Payment information securely handled by third-party processors.</p>

            <h3>Social Media, Forums & Blogs</h3>
            <p>Information shared when interacting on public platforms.</p>

            <h3>Tracking Technologies</h3>
            <ul>
              <li>Cookies</li>
              <li>Web Beacons</li>
              <li>Tags & Widgets</li>
              <li>Google Analytics</li>
            </ul>

            <div className="policy-divider" />

            <h2>HOW DO WE USE PERSONAL INFORMATION?</h2>
            <ul>
              <li>Provide and manage services</li>
              <li>Process and deliver orders</li>
              <li>Customer support and communication</li>
              <li>Marketing and promotions</li>
              <li>Improve products and services</li>
              <li>Legal compliance</li>
            </ul>

            <div className="policy-divider" />

            <h2>DO WE SHARE PERSONAL INFORMATION?</h2>
            <p>
              We may share information with affiliates, service providers, payment processors,
              and authorities when required by law.
            </p>

            <div className="policy-divider" />

            <h2>HOW DO WE SECURE YOUR INFORMATION?</h2>
            <p>
              We implement physical, technical, and administrative safeguards including SSL encryption.
            </p>

            <div className="policy-divider" />

            <h2>YOUR DATA PROTECTION RIGHTS</h2>
            <ul>
              <li>Right to access</li>
              <li>Right to correction</li>
              <li>Right to deletion</li>
              <li>Right to opt-out</li>
              <li>Right to data portability</li>
            </ul>

            <div className="policy-divider" />

            <h2>CONTACT US</h2>
            <p><strong>Email:</strong> legal@nxoptics.com</p>
            <p><strong>Phone:</strong> +1 (888) 468-9910</p>
            <p><strong>Address:</strong> 15241 Don Julian Rd, City of Industry, CA 91745, USA</p>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
